"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { pushDataLayer } from "@/lib/data-layer";

type KeycloakGtmTrackingProps = {
  children: React.ReactNode;
};

export default function KeycloakGtmTracking({
  children,
}: KeycloakGtmTrackingProps) {
  const searchParams = useSearchParams();
  const path = usePathname();
  const splittedPath = path.split("/");
  const login = searchParams.get("fromLogin");
  const register = searchParams.get("fromRegister");
  const isCheckout = splittedPath.includes("checkout");
  const isFirstStep = splittedPath.pop() === "1";

  useEffect(() => {
    // sign_up / login non trasportano un oggetto ecommerce: nessun reset.
    if (
      (login && register && !isCheckout) ||
      (isCheckout && isFirstStep && login && register)
    ) {
      pushDataLayer({
        event: "sign_up",
        method: "Modulo Registrazione Email",
      });
    } else if (
      (login && !register && !isCheckout) ||
      (isCheckout && isFirstStep && login && !register)
    ) {
      pushDataLayer({
        event: "login",
        method: "Email e Password'",
      });
    }
  }, []);

  return <>{children}</>;
}
